import type { ReactNode } from 'react';

export const symbol_data_loss_prevention: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M430.09-580q28.91 0 49.41-20.59 20.5-20.59 20.5-49.5t-20.59-49.41q-20.59-20.5-49.5-20.5t-49.41 20.59q-20.5 20.59-20.5 49.5t20.59 49.41q20.59 20.5 49.5 20.5Zm.41 160q38.5 0 74.71-15.88Q541.42-451.75 568-481q-32-20-67-29.5t-71-9.5q-36 0-71 9.5T292-481q28 29 64 45t74.5 16Zm-.44 160Q301-260 210.5-350.5T120-570q0-129 90.5-219.5T430-880q129 0 219.5 90.5T740-569.94q0 53.94-19.5 105.44T669-373l190 190q9 9 9 21t-9 21q-9 9-21 9t-21-9L627-331q-40 32-91.5 51.5T430.06-260Zm.44-60Q534-320 607-393.5t73-177Q680-674 607.08-747 534.17-820 430-820q-103 0-176.5 72.92Q180-674.17 180-570q0 103 73.5 176.5t177 73.5Zm-.5-250Z"
		/>
	</svg>
);
